import { render, staticRenderFns } from "./addPaymentType.vue?vue&type=template&id=d47a0bb6&scoped=true&"
import script from "./addPaymentType.vue?vue&type=script&lang=js&"
export * from "./addPaymentType.vue?vue&type=script&lang=js&"
import style0 from "./addPaymentType.vue?vue&type=style&index=0&id=d47a0bb6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d47a0bb6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\sdk_manage_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d47a0bb6')) {
      api.createRecord('d47a0bb6', component.options)
    } else {
      api.reload('d47a0bb6', component.options)
    }
    module.hot.accept("./addPaymentType.vue?vue&type=template&id=d47a0bb6&scoped=true&", function () {
      api.rerender('d47a0bb6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/payment/components/addPaymentType.vue"
export default component.exports